import React from 'react';
import SearchWithParams from '../components/SearchWithParams';

const Search = props => (
    <SearchWithParams mode="default" {...props} />
);

export default Search;
